import { MAPS } from '@/maps';
import { HARBOR_EDGE_MAP } from './harborEdge';

export { HARBOR_EDGE_MAP } from './harborEdge';

let registered = false;
export function registerPrologueMaps(): void {
  if (registered) return;
  registered = true;
  MAPS[HARBOR_EDGE_MAP.id] = HARBOR_EDGE_MAP;
}
